import { render, staticRenderFns } from "./SampleUpdatedBody.vue?vue&type=template&id=baa78ec2&"
import script from "./SampleUpdatedBody.vue?vue&type=script&lang=js&"
export * from "./SampleUpdatedBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports